import { Message, Loading } from "ccui";
import { addUrlPerFix } from "@/basa/utils";

export const loadingParams = { isShowLoading: true };

export function showErrorMessage(message) {
  return Message({
    message,
    type: "error",
    showClose: true,
    ccuiCustom: true,
    duration: 1000 * 8
  });
}
//流转文件

export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
export function showLoading(loadingText = "加载中") {
  return Loading.service({
    lock: true,
    text: `${loadingText}...`,
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.2)",
    customClass: "ccui-custom-loading"
  });
}

export function exportData({ data }) {
  let openUrl = document.createElement("a");
  openUrl.style.display = "none";
  openUrl.href = `${addUrlPerFix(
    process.env.VUE_APP_BASE_URL
  )}/apis/smp/oss/downloadByUploadId?uploadId=${data.data.fileRspBo.uploadId}`;
  openUrl.setAttribute("download", data.data.fileRspBo.fileName);
  document.body.appendChild(openUrl);
  openUrl.click();
}
export function watermark(settings) {
  document.getElementById("watermarks").innerHTML = "";
  //默认设置
  let defaultSettings = {
    watermark_txt: settings.watermark_txt || "text",
    watermark_x: 10, //水印起始位置x轴坐标
    watermark_y: 10, //水印起始位置Y轴坐标
    watermark_rows: 80, //水印行数
    watermark_cols: 80, //水印列数
    watermark_x_space: 30, //水印x轴间隔
    watermark_y_space: 30, //水印y轴间隔
    watermark_color: "#666", //水印字体颜色
    watermark_alpha: 0.2, //水印透明度
    watermark_fontsize: "15px", //水印字体大小
    watermark_font: "微软雅黑", //水印字体
    watermark_width: 240, //水印宽度
    watermark_height: 30, //水印长度
    watermark_angle: 10 //水印倾斜度数
  };
  //采用配置项替换默认值，作用类似jquery.extend
  if (arguments.length === 1 && typeof arguments[0] === "object") {
    let src = arguments[0] || {};
    for (let key in src) {
      if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key])
        continue;
      else if (src[key]) defaultSettings[key] = src[key];
    }
  }

  let oTemp = document.createDocumentFragment();
  console.log(document.body, " document.body");
  //获取页面最大宽度
  let page_width = Math.max(
    document.body.scrollWidth,
    document.body.clientWidth,
    1980
  );
  //获取页面最大长度
  let page_height = Math.max(
    document.body.scrollHeight,
    document.body.clientHeight
  );
  console.log(page_width, "page_width");
  //如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
  if (
    defaultSettings.watermark_cols == 0 ||
    parseInt(
      defaultSettings.watermark_x +
        defaultSettings.watermark_width * defaultSettings.watermark_cols +
        defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)
    ) > page_width
  ) {
    defaultSettings.watermark_cols = parseInt(
      (page_width -
        defaultSettings.watermark_x +
        defaultSettings.watermark_x_space) /
        (defaultSettings.watermark_width + defaultSettings.watermark_x_space)
    );
    defaultSettings.watermark_x_space = parseInt(
      (page_width -
        defaultSettings.watermark_x -
        defaultSettings.watermark_width * defaultSettings.watermark_cols) /
        (defaultSettings.watermark_cols - 1)
    );
  }
  //如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
  if (
    defaultSettings.watermark_rows == 0 ||
    parseInt(
      defaultSettings.watermark_y +
        defaultSettings.watermark_height * defaultSettings.watermark_rows +
        defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)
    ) > page_height
  ) {
    defaultSettings.watermark_rows = parseInt(
      (defaultSettings.watermark_y_space +
        page_height -
        defaultSettings.watermark_y) /
        (defaultSettings.watermark_height + defaultSettings.watermark_y_space)
    );
    defaultSettings.watermark_y_space = parseInt(
      (page_height -
        defaultSettings.watermark_y -
        defaultSettings.watermark_height * defaultSettings.watermark_rows) /
        (defaultSettings.watermark_rows - 1)
    );
  }
  let x;
  let y;
  for (let i = 0; i < defaultSettings.watermark_rows; i++) {
    y =
      defaultSettings.watermark_y +
      (defaultSettings.watermark_y_space + defaultSettings.watermark_height) *
        i;
    for (let j = 0; j < defaultSettings.watermark_cols; j++) {
      x =
        defaultSettings.watermark_x +
        (defaultSettings.watermark_width + defaultSettings.watermark_x_space) *
          j;

      let mask_div = document.createElement("div");
      mask_div.id = "mask_div" + i + j;
      mask_div.className = "mask_div";
      mask_div.appendChild(
        document.createTextNode(defaultSettings.watermark_txt)
      );
      //设置水印div倾斜显示
      mask_div.style.MozTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.msTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.OTransform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.transform =
        "rotate(-" + defaultSettings.watermark_angle + "deg)";
      mask_div.style.visibility = "";
      mask_div.style.position = "fixed";
      mask_div.style.left = x + "px";
      mask_div.style.top = y + "px";
      mask_div.style.overflow = "hidden";
      mask_div.style.zIndex = "9999";
      //mask_div.style.border="solid #eee 1px";
      mask_div.style.opacity = defaultSettings.watermark_alpha;
      mask_div.style.fontSize = defaultSettings.watermark_fontsize;
      mask_div.style.fontFamily = defaultSettings.watermark_font;
      mask_div.style.color = defaultSettings.watermark_color;
      mask_div.style.textAlign = "center";
      mask_div.style.width = defaultSettings.watermark_width + "px";
      mask_div.style.height = defaultSettings.watermark_height + "px";
      mask_div.style.display = "block";
      mask_div.style.pointerEvents = "none";
      oTemp.appendChild(mask_div);
    }
  }
  // document.body.appendChild(oTemp);
  document.getElementById("watermarks").appendChild(oTemp);
}
